<template>
  <v-content>
    <v-container fluid fill-height>



      <v-flex xs12>
        <v-card color="blue-grey darken-2" class="white--text">
          <v-card-title primary-title>
            <div class="headline">Download Analyzer</div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat href="http://vrc.api.maxis.io:8000/static/VSS-Analyzer-Master.exe">Download</v-btn>
          </v-card-actions>
        </v-card>

        <v-card color="blue-grey darken-2" class="white--text">
          <v-card-title primary-title>
            <div class="headline">Download FrameSorter/DataEntry Suite</div>
          </v-card-title>
          <v-card-actions>
            <v-btn flat href="http://vrc.api.maxis.io:8000/static/FrameSorter-Master.exe">Download</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

    </v-container>
  </v-content>
</template>

<script>
  export default {
    name: 'Downloads',
    data () {
      return {
        downloadUrls: ["http://vrc.api.maxis.io:8000/static/framesorter.json", "http://vrc.api.maxis.io:8000/static/analyzer.json"],
        downloadObjects: [],
      }
    },
    methods: {

    },
    mounted: function() {
      this.getLatestDownloads();

    }
  }
</script>

<style>
  .login-wrapper {
    width: 80%;
    height: 80%;
    margin: 15% auto;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #42a5f5 inset;
  }

  input:-webkit-autofill,
  input:focus:-webkit-autofill {
    -webkit-box-shadow: 0 0 0px 1000px #42a5f5 inset;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/Downloads.vue